<template>
    <div>
        <h3 @click="enableDebug($event)" class="display-4">
            Manage Permissions
        </h3>

        <o-list-toolbar
            :filters-list="filter_list"
            :list-options="list_options"
            :new-to="{ name: 'permission.create', params: { id: 0 } }"
            :query-select-options="options"
            :schema="schema"
            :search-fields-list="search_field_list"
            :selected-filter="selected_filter"
            @filter_changed="update_filter($event)"
            @options_changed="update_table($event)"
            @reset_table="reset_table"
            new-button-text="New Permission"
        >
        </o-list-toolbar>

        <BTable
            :fields="fields"
            :items="items"
            :sort-by="list_options.sort"
            :sort-desc="list_options.order == 'desc'"
            @sort-changed="change_sort"
            bordered
            head-variant="light"
            no-local-sorting
            striped
        >
            <template #cell(name)="{ index, item }">
                <router-link
                    :to="{ name: 'permission.edit', params: { id: item.id } }"
                >
                    <default-display :value="item.name"></default-display>
                </router-link>
            </template>
            <template #cell(content_type)="{ index, item }">
                <lookup-display
                    :list="optionContentTypeItemsById"
                    :value="item.content_type"
                    default-value="-"
                    display-field="app_label"
                ></lookup-display>
            </template>
            <template #cell(codename)="{ index, item }">
                <default-display :value="item.codename"></default-display>
            </template>

            <template slot="empty">
                <p>
                    <emoticon-sad-icon large></emoticon-sad-icon>
                </p>
                No Data Found. Please
                <router-link :to="{ name: 'permission.create' }"
                    >create a new item</router-link
                >
            </template>
        </BTable>

        <o-list-paging
            :limit="list_options.limit"
            :offset="list_options.offset"
            :page-options="rows_per_page_items"
            :total-items="total_items"
            @change-limit="change_limit"
            @change-page="change_page"
        />
    </div>
</template>

<style></style>

<script>
import { BTable } from "bootstrap-vue";
import {
    CreateCodeTableFetchMixin,
    CreateListPageMixin,
} from "../../../mixins";
import {
    fieldToTableColumn,
    GetSearchFields,
} from "../../../schema/schema_utils.js";
import schema from "../../schema/index.js";

import OListToolbar from "../../../components/list/OListToolbar.vue";
import OListPaging from "../../../components/list/OListPaging.vue";
import DefaultDisplay from "../../../components/display/DefaultDisplay.vue";
import DateDisplay from "../../../components/display/DateDisplay.vue";
import NumberDisplay from "../../../components/display/NumberDisplay.vue";
import BooleanDisplay from "../../../components/display/BooleanDisplay.vue";
import LookupDisplay from "../../../components/display/LookupDisplay.vue";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad.vue";
import EmailIcon from "vue-material-design-icons/Email.vue";
import LinkIcon from "vue-material-design-icons/Link.vue";

export default {
    components: {
        BTable,
        EmoticonSadIcon,
        EmailIcon,
        LinkIcon,
        OListPaging,
        OListToolbar,
        DateDisplay,
        DefaultDisplay,
        BooleanDisplay,
        NumberDisplay,
        LookupDisplay,
    },
    mixins: [
        CreateListPageMixin("Permission", "permission"),
        CreateCodeTableFetchMixin(["ContentType"]),
    ],

    data: function () {
        return {
            schemaModel: schema.Permission,

            search_field_list: GetSearchFields(schema.Permission),

            filter_list: [
                {
                    name: "Active",
                    code: "active",
                    options: { offset: 0, sort: "id" },
                },
                {
                    name: "Non Active",
                    code: "inactive",
                    options: { offset: 0, sort: "id" },
                },
                {
                    name: "All",
                    code: "all",
                    options: { offset: 0, sort: "id" },
                },
            ],
        };
    },
    computed: {
        options() {
            return {
                ContentType: {
                    options: this.optionContentTypeItems,
                    textField: "app_label",
                    valueField: "id",
                },
            };
        },
        fields() {
            return [
                fieldToTableColumn(this.schema, "name"),
                fieldToTableColumn(this.schema, "content_type"),
                fieldToTableColumn(this.schema, "codename"),
            ];
        },
    },
};
</script>
